import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import QuantityButtons from '../QuantityButtons';
import { getVariantMinMaxQuantity } from '../helpers';
import { BLAZE_DEFAULT_MIN_QUANTITY } from '../constants';

const FlyOutBasketItem = ({ basketItem, className }) => {
  const { handleUpdateCartItems } = useEcommerceContext();

  const {
    quantity,
    formattedTotalPrice,
    variantId,
    publishedProduct: { id, name, url, image, variants }
  } = basketItem;
  const { url: imageUrl } = image || {};

  const handleQuantityUpdate = value => {
    handleUpdateCartItems({
      lineItems: [{ productId: id, variantId, quantity: Number(value) || 1 }]
    });
  };

  const itemClassName = `${className}__item`;
  const { minQuantity, maxQuantity } = getVariantMinMaxQuantity(variantId, variants);

  return (
    <div className={itemClassName}>
      <div className={`${itemClassName}__image`}>
        <ResponsiveImage src={imageUrl} alt={name} sizeKey="ecommerce_flyout_basket" />
      </div>
      <div className={`${itemClassName}__details`}>
        <Link href={url} className={`${itemClassName}__details__title`}>
          {name}
        </Link>
        {formattedTotalPrice && (
          <span className={`${itemClassName}__details__total`}>{formattedTotalPrice}</span>
        )}
      </div>
      <QuantityButtons
        minValue={minQuantity || BLAZE_DEFAULT_MIN_QUANTITY}
        maxValue={maxQuantity}
        handleQuantityUpdate={handleQuantityUpdate}
        initialValue={quantity}
      />
    </div>
  );
};

FlyOutBasketItem.propTypes = {
  basketItem: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired
};

export default FlyOutBasketItem;
